import { Injectable } from "@angular/core";
import { v4 as uuidv4 } from 'uuid';
import { WebSocketGraylogService } from "../socket/socket";
import { Span } from "@opentelemetry/sdk-trace-web";
import { environment } from "src/environments/environment";
import { getInstanceId } from "src/app/module/chat/domain/chat-service.service";


export class OpenTelemetryLogging {

  socket = new WebSocketGraylogService()

  constructor() {

    if(environment.apiURL != 'https://gdqas-api.oapr.gov.ao/api/') {
      // this.socket.start()
    }

  }

  async send({
    level,
    message,
    payload
  }: {
    level: string,
    message: string,
    payload: Record<string, any>,
  }): Promise<void> {
    const nanoTimestamp = (Date.now() * 1_000_000).toString();

    const logMessage = {
      message,
      details: { ...payload },
    };

    const logData = {
      streams: [
        {
          stream: {
            level,
            k2: "true",
            app: "angular-app",
            instanceId: getInstanceId(),
          },
          values: [[nanoTimestamp, JSON.stringify(logMessage)]], // ✅ FIXED
        },
      ],
    };

    try {
      const response = await fetch("https://logs.petermaquiran.xyz/loki/api/v1/push", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(logData),
      });

      if (response.status !== 204) {
        // Optional: handle failed log delivery
        console.warn(`Failed to send log: ${response.status}`);
      }
    } catch (error) {
      // Optional: handle fetch error
      console.error("Log sending error:", error);
    }
  }

}

export const openTelemetryLogging = new OpenTelemetryLogging()
